import OverflowMenuVertical16 from '@carbon/icons-react/es/overflow-menu--vertical/16';
import { Dropdown, DropDownProps, Tooltip } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { IconWrapper } from '../icon-shell/icon-shell';

export interface MoreActionsDropdownProps
  extends Omit<DropDownProps, 'overlay' | 'trigger'> {
  menu: React.ReactElement;
  tooltipText?: JSX.Element;
  dataCyValue?: string;
  hideHoverBorderRadius?: boolean;
}

export const MoreActionsDropdown: FC<MoreActionsDropdownProps> = ({
  menu,
  className,
  overlayClassName,
  placement = 'bottomRight',
  tooltipText,
  dataCyValue = 'buttons.more-actions',
  hideHoverBorderRadius = false,
  ...restProps
}) => {
  const moreActionsText = useTranslation('more_actions');

  return (
    <Dropdown
      className={className}
      overlayClassName={overlayClassName}
      overlay={menu}
      placement={placement}
      trigger={['click']}
      {...restProps}
    >
      <Tooltip title={tooltipText ?? moreActionsText}>
        <Button
          type="text"
          icon={
            <IconWrapper>
              <OverflowMenuVertical16 />
            </IconWrapper>
          }
          size="small"
          data-cy={dataCyValue}
          hideHoverBorderRadius={hideHoverBorderRadius}
        />
      </Tooltip>
    </Dropdown>
  );
};
